
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"80","height":"80","viewBox":"0 0 80 80","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M57.578 25.675v12.338c0 .656-.525 1.181-1.181 1.181a1.176 1.176 0 01-1.182-1.181V25.675c0-.656-.525-1.181-1.18-1.181H43.008a1.176 1.176 0 01-1.181-1.181c0-.657.525-1.182 1.181-1.182h10.894c2.1-.13 3.675 1.444 3.675 3.544zM55.084 55.075V42.87c0-.656.525-1.181 1.182-1.181.656 0 1.181.525 1.181 1.181v12.206c.131 1.97-1.575 3.675-3.544 3.675H43.01a1.176 1.176 0 01-1.181-1.18c0-.657.525-1.182 1.181-1.182h10.894c.657-.131 1.181-.656 1.181-1.313zM27.128 22h10.894c.656 0 1.181.525 1.181 1.181 0 .657-.525 1.182-1.181 1.182H26.997c-.657 0-1.181.525-1.181 1.181V37.75c0 .656-.525 1.181-1.182 1.181a1.176 1.176 0 01-1.181-1.18V25.674c0-1.969 1.706-3.675 3.675-3.675zM25.946 55.075c0 .657.525 1.182 1.181 1.182h10.894c.657 0 1.182.525 1.182 1.18 0 .657-.525 1.182-1.182 1.182H26.996c-1.968 0-3.675-1.575-3.675-3.675V42.738c0-.656.525-1.181 1.181-1.181.657 0 1.182.525 1.182 1.181v12.338h.262z","fill":"#fff"}}),_c('path',{attrs:{"d":"M37.103 52.713l6.956-9.188c.13-.262.525-.262.787 0l6.956 9.188c.263.262 0 .787-.394.787h-13.78c-.526 0-.657-.525-.526-.787z","fill":"#fff"}}),_c('path',{attrs:{"d":"M29.49 52.713l4.069-4.069c.131-.131.525-.131.656 0l4.069 4.069c.263.262.131.788-.394.788h-8.137c-.263 0-.525-.526-.263-.788z","fill":"#fff"}}),_c('path',{attrs:{"d":"M30.015 32.5a2.624 2.624 0 105.25 0 2.624 2.624 0 10-5.25 0z","fill":"#C1AB8E"}})])
          )
        }
      }
    